module.exports = __webpack_public_path__ + "static/media/product4.aeca8662.jpg";